module.exports = __webpack_public_path__ + "static/media/subscript.9ed5c24e.svg";